import React, { FC, useState } from 'react';
import { IModalWindow, MODAL_TYPE, ModalWindow } from '../modal/ModalWindow';
import { useTranslation } from 'react-i18next';
import { Dropdown } from 'rsuite';
import { approveApplication, declineApplication, reopenApplication } from '../../api/new-application-api-service';
import { useNavigate, useParams } from 'react-router-dom';
import { useLocation } from 'react-router';
import { fetchRegularApplicationData } from '../../store/merchnts/actions/application';
import { useMerchants } from '../../store/merchnts/merchants-context';
import { MERCHANTS_TABS } from '../../utils/merchantUtils';

enum APPLICATION_STATUSES {
  APPROVED = 'approved',
  DECLINED = 'declined',
  DRAFT = 'draft',
}

const applicationStatuses = [
  {
    name: 'APPLICATION_DETAILS.LABEL.STATUS_DRAFT',
    status: APPLICATION_STATUSES.DRAFT,
  },
  {
    name: 'APPLICATION_DETAILS.LABEL.STATUS_APPROVED',
    status: APPLICATION_STATUSES.APPROVED,
  },
  {
    name: 'APPLICATION_DETAILS.LABEL.STATUS_DECLINED',
    status: APPLICATION_STATUSES.DECLINED,
  },
];

export const ReviewFooterActions: FC = () => {
  const { t } = useTranslation();
  const { applicationId } = useParams<{ applicationId: string }>();
  const { state } = useLocation();
  const navigate = useNavigate();
  const { dispatch } = useMerchants();

  const [modalState, setModalState] = useState<IModalWindow>({
    isOpen: false
  });

  const [additionalModalState, setAdditionalModalState] = useState<IModalWindow>({
    isOpen: false
  });

  const closeModal = (): void => setModalState(prev => ({ ...prev, isOpen: false }));
  const closeAdditionalModal = (): void => setAdditionalModalState(prev => ({ ...prev, isOpen: false }));

  const handleApproveSuccess = (): void => {
    closeModal();
    setAdditionalModalState({
      isOpen: true,
      modalType: MODAL_TYPE.APPROVE,
      minHeight: 150,
      modalTitle: 'Application approved',
      modalText: 'This application has been converted to a merchant',
      confirmButtonText: 'To merchant',
      onConfirm: () => navigate(`/accounts/merchants/${applicationId}/${MERCHANTS_TABS.BUSINESS}`),
      cancelButtonText: 'Back to applications',
      onCancel: () => navigate(`/accounts/applications`),
      onClose: () => navigate(`/accounts/applications`),
    });
  };
  // const handleApproveError = (): void => {
  //   closeModal();
  //   setAdditionalModalState({
  //     isOpen: true,
  //     modalType: MODAL_TYPE.DECLINE,
  //     minHeight: 150,
  //     modalTitle: 'Approve application error',
  //     modalText: 'Something went wrong. Please try again later',
  //     confirmButtonText: 'Ok',
  //     onConfirm: closeAdditionalModal,
  //     onClose: closeAdditionalModal,
  //   });
  // };

  const handleDeclineSuccess = (): void => navigate(`/accounts/applications?pageNumber=${state?.pageNumber}&pageSize=${state?.pageSize}`);

  const handleReopenSuccess = async (): Promise<void> => {
    closeModal();
    await fetchRegularApplicationData({ dispatch, applicationId });
  };

  const handleSelect = (fieldName: string): void => {
    try {

      switch (fieldName) {
        case APPLICATION_STATUSES.APPROVED:
          setModalState({
            isOpen: true,
            minHeight: 150,
            modalTitle: t('NEW_APPLICATION.APPROVE_APP_TITLE'),
            modalText: t('NEW_APPLICATION.APPROVE_APP_TEXT'),
            onConfirm: async (): Promise<void> => {
              await approveApplication({ applicationId, onSuccess: handleApproveSuccess, onError: closeModal });
            },
            onCancel: closeModal
          });
          break;
        case APPLICATION_STATUSES.DECLINED:
          setModalState({
            isOpen: true,
            modalType: MODAL_TYPE.DECLINE,
            modalTitle: t('NEW_APPLICATION.DECLINE_APP_TITLE'),
            modalText: t('NEW_APPLICATION.DECLINE_APP_TEXT'),
            confirmButtonText: 'Confirm',
            onConfirm: async (): Promise<void> => {
              await declineApplication({ applicationId, handleSuccess: handleDeclineSuccess, onError: closeModal });
            },
            onCancel: closeModal
          });
          break;
        case APPLICATION_STATUSES.DRAFT:
          setModalState({
            isOpen: true,
            modalType: MODAL_TYPE.DECLINE,
            modalTitle: t('NEW_APPLICATION.REOPEN_MODAL_TITLE'),
            modalText: t('NEW_APPLICATION.REOPEN_MODAL_TEXT'),
            confirmButtonText: 'Confirm',
            onConfirm: async (): Promise<void> => {
              await reopenApplication({ applicationId, handleSuccess: handleReopenSuccess, onError: closeModal });
            },
            onCancel: closeModal
          });
          break;
        default:
          break;
      }

    } catch (error) {
      console.error('handleSelect', error);
    }
  };

  return (
    <>
      <div className="save-btn-section">
        <Dropdown
          title={t('APPLICATION_DETAILS.LABEL.APPLICATION_REVIEW')}
          placement="bottomStart"
          className="new-app-actions w-100"
        >
          {
            applicationStatuses.map(({ name, status }) => {
              return (
                <Dropdown.Item
                  key={name}
                  onClick={(): void => handleSelect(status)}
                  className="fw-bolder fs-7 text-muted"
                >
                  {t(name)}
                </Dropdown.Item>
              );
            })
          }
        </Dropdown>
      </div>

      <ModalWindow
        {...modalState}
        onClose={closeModal}
      />

      <ModalWindow
        {...additionalModalState}
      />
    </>
  );
};